import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import classes from './RecommendedResourceIndicator.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/features/allHome/utils/Language/AllHome-translations';

const RecommendedResourceIndicator = ({ resource }) => {
  const renderTooltip = (props) => (
    <Tooltip id="recommended-resource-tooltip" {...props} className={classes.tooltipText}>
      {t('This resource was recommended by our team because it currently serves many people in your county.')}
    </Tooltip>
  );

  const indicationBlock = resource?.properties && resource.properties['shba-boost'] && (
    <OverlayTrigger overlay={renderTooltip}>
      <span className={classes.recommendedResource}>
        {t('Recommended Resource')}
        <div>
          <FontAwesomeIcon icon="fa-solid fa-info-circle" />
        </div>
      </span>
    </OverlayTrigger>
  );

  return <>{indicationBlock}</>;
};
export default RecommendedResourceIndicator;
